import React, { useState } from 'react';

import Show from 'components/Show';
import Action from 'components/Misc/Action';
import { Title } from 'components/Misc/Typography';
import { Container } from 'components/Misc/Sortable';

import Add from 'containers/Administrator/Blanks/Create/Courses/Add';
import Course from 'containers/Administrator/Blanks/Create/Courses/Course';

import { useBlankCreateStore } from 'store/blank/useBlankCreateStore';

const Courses = () => {
	// Use blank's creation storet
	const [courses, onSortCourse] = useBlankCreateStore(state => [state.blank.courses, state.onSortCourse]);

	// Store modal's visibility
	const [modal, setModal] = useState(false);

	// Toggle modal's visibility
	const handleModal = () => setModal(m => !m);

	return (
		<>
			<Title
				title="Moduļi"
				className="text-lg"
			/>

			{/* Selected courses */}
			<Show if={courses?.length}>
				<Container
					lockAxis="y"
					lockOffset="0%"
					lockToContainerEdges
					useDragHandle
					onSortEnd={onSortCourse}
					className="flex flex-col gap-4"
				>
					{courses.map((course, idx) =>
						<Course
							isSelected
							key={course.id}
							idx={idx}
							course={course}
						/>
					)}
				</Container>
			</Show>

			{/* Course modal toggle */}
			<Action
				icon="book"
				title="Pievienot moduli"
				subtitle="Piesaistiet sagatavei mācību moduļus"
				onClick={handleModal}
			/>

			{/* Course selection modal */}
			<Add modal={modal} handleModal={handleModal} />
		</>
	);
};

export default Courses;